<template>
    <div class="row">
        <div :class="forecastWindow ? 'col-lg-6' : 'col-lg-3'">
            <div class="SectionTitle">general dates</div>
            <div class="normal-text">
                Ref date : <span class="bold">{{ formDate(forecast.refDate) }}</span
                ><br />
                Availability date : <span class="bold">{{ forecast.availabilityDate ? formDate(forecast.availabilityDate) : "-" }}</span> <br />
                Launch date : <span class="bold">{{ forecast.launchDate ? formDate(forecast.launchDate) : "-" }}</span> <br />
                Animation Campaign : {{ forecast.campaign.name }} <br />
                Preseries date : <span class="bold">{{ forecast.preseriesDate ? formDate(forecast.preseriesDate) : "-" }}</span> <br />
                End of campaign : <span class="bold">{{ forecast.endOfCampaign ? formDate(forecast.endOfCampaign) : "-" }}</span> <br />

                <p>
                    Recurrence : <span class="bold normal-text">{{ forecast.recurrenceAmount }} months</span>
                </p>
            </div>
        </div>

        <div class="col-lg-6 d-flex align-items-end justify-content-end">
            <History :object="forecast" :object-type="OBJECT_TYPE.FORECASTS" :is-dark="false"></History>
        </div>

        <div class="col-lg-3">
            <div class="SectionTitle" v-if="useForecastDatesForZone">forecast manager dates</div>
            <div class="SectionTitle" v-else>zone manager dates</div>
            <div class="normal-text">
                Start Date: <span class="bold">{{ formDate(startDateToShow) }}</span> <br />
                End Date: <span class="bold">{{ formDate(endDateToShow) }}</span> <br />
            </div>
        </div>
    </div>
</template>
<script>
import { formatDate as fDate } from "@/components/forecasts/utils/utilis";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import History from "@/components/history/History";
import { OBJECT_TYPE } from "@/components/history/constants";

export default {
    components: { History },
    props: {
        forecast: {
            type: Object,
            required: true
        },
        forecastWindow: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            PROFILES,
            OBJECT_TYPE
        };
    },
    computed: {
        useForecastDatesForZone() {
            if (!this.forecastWindow) {
                return true;
            }
            if (this.forecast.publishMode === "all_zones") {
                return true;
            }
            if (!this.forecastWindow.multiValidation) {
                return true;
            }
            return !this.forecastWindow.startDate;
        },
        startDateToShow() {
            return this.useForecastDatesForZone ? this.forecast.startDate : this.forecastWindow.startDate;
        },
        endDateToShow() {
            return this.useForecastDatesForZone ? this.forecast.endDate : this.forecastWindow.endDate;
        }
    },
    methods: {
        formDate(date) {
            return fDate(date);
        },
        hasAccessByProfile(profile) {
            return this.$accessUser.hasAccessByProfile(profile);
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../css/forecasts.scss";

.normal-text {
    text-transform: none;
}
</style>



// WEBPACK FOOTER //
// DateInfosDetail.vue?b804f74e